
import axios from 'axios'
// 标准时间转日期格式
const utils = {
  msToDate: function (msec) {
    const datetime = new Date(msec)
    const year = datetime.getFullYear()
    const month = datetime.getMonth()
    const date = datetime.getDate()
    const hour = datetime.getHours()
    const minute = datetime.getMinutes()
    const second = datetime.getSeconds()

    const result1 =
      year +
      '-' +
      (month + 1 >= 10 ? month + 1 : '0' + (month + 1)) +
      '-' +
      (date + 1 < 10 ? '0' + date : date) +
      ' ' +
      (hour + 1 < 10 ? '0' + hour : hour) +
      ':' +
      (minute + 1 < 10 ? '0' + minute : minute) +
      ':' +
      (second + 1 < 10 ? '0' + second : second)

    const result2 =
      year +
      '-' +
      (month + 1 >= 10 ? month + 1 : '0' + (month + 1)) +
      '-' +
      (date + 1 < 10 ? '0' + date : date)

    const result = {
      hasTime: result1,
      withoutTime: result2
    }

    return result
  },
  downloadFile: function (url) {
    // 创建一个隐藏的a标签
    const a = document.createElement('a')
    a.href = url
    document.body.appendChild(a)
    a.click() // 模拟点击下载文件
    document.body.removeChild(a) // 下载完成移除元素
  },
  svgToBase64 (path) {
    console.log(path, '/base64?img_path>>>>>>>>>>>')
    axios.get(`http://127.0.0.1:8681/test/base64?img_path=${path}`).then(response => {
      console.log(response, 'response0000000>>>')
      return response.data.base64
    }, () => {
      return ''
    })
  }
 
}

export default utils
